function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.657 2.256C14.378 2.256 10.299 13.149 11.636 22c-1.452 6.643.263 10.09 4.085 11.06l2.723 10.046c2.724 5.447 17.702 5.447 20.425 0l2.724-10.045c4.343-.848 5.705-4.933 4.085-11.061 1.25-8.85-2.742-19.744-17.021-19.744z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.156 19.958a3.404 4.766 64.623 01-2.847 5.119 3.404 4.766 64.623 01-5.765-1.034 3.404 4.766 64.623 012.847-5.118 3.404 4.766 64.623 015.765 1.033zm5.005 0a4.766 3.404 25.377 002.847 5.119 4.766 3.404 25.377 005.765-1.034 4.766 3.404 25.377 00-2.847-5.118 4.766 3.404 25.377 00-5.765 1.033zM31.38 32.893c0 3.384-1.33.836-2.834.836s-2.613 2.548-2.613-.836 1.22-6.128 2.724-6.128 2.723 2.744 2.723 6.128z",
  strokeWidth: 1.002,
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "var(--primary-color, #000)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.657 40.754v6.437m3.745-7.081v6.437m-7.49-6.437v6.437m11.234-7.935v6.573m-14.978-6.709v6.573m-5.447-11.988v14.13c0 5.036 8.264 6.707 12.936 6.808 5.073.11 12.936-2.256 12.936-6.808V33.574"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.271 39.021c-4.125 4.085-6.848 5.447-11.574 5.447-4.805 0-8.465-1.958-11.574-5.447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.721 34.936c3.296 3.127 8.822 5.517 12.936 5.447 5.163.033 9.826-2.58 12.936-6.07"
}));

var SvgSkull = function SvgSkull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Skull.7df899f9.svg";
export { ForwardRef as ReactComponent };